export default __webpack_public_path__ + "static/media/csi-logo.ad29ae90.png";